<template>
	<div>
		<HeadIndex></HeadIndex>
		<div ref="height_top" class="product">
			<el-row>
				<el-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 24, offset: 0 }" :md="{ span: 24, offset: 0 }"
					:lg="{ span: 22, offset: 1 }" :xl="{ span: 20, offset: 2 }" class="shop custom-col-20 offset-col-2"
					v-bind:style="{ height: tableHeight - 60 + 'px' }">
					<el-row style="padding:10px 0px 10px 10px">
						<el-col :xs="{ span: 6, offset: 0 }" :sm="{ span: 6, offset: 0 }" :md="{ span: 6, offset: 0 }"
					:lg="{ span: 6, offset: 0 }" :xl="{ span: 8, offset: 0 }" class="custom-col-8" style="">
							<el-row>
								<el-col :span="24" class="" style="">
									<el-carousel ref="carousel" v-model="activeIndex" :height="'50vh'"
										style="text-align: center; border: 3px solid rgb(233, 233, 235);">
										<div
											style="display: flex;align-items: center; justify-content: center;height: 100%;">
											<span
												style="color: rgb(139, 139, 139);font-weight: bold;font-size: 0.875rem;">
												用户暂未上传图片
											</span>
										</div>
										<el-carousel-item v-for="(item, key) in data.img" :key="key" height="50vh">
											<el-image :src="item" @click="preview(key)" fit="cover"
												style="height:100%;width:100%" />
										</el-carousel-item>
									</el-carousel>
								</el-col>
								<!-- 缩略图容器（带左右箭头） -->
								<el-col :span="24" style="margin-top: 10px; position: relative;">
									<el-button icon="ArrowLeft" circle size="mini"
										style="position: absolute; left: 0; top: 50%; transform: translateY(-50%); z-index: 1;"
										@click="scrollThumbnails(-1)"></el-button>
									<!-- 缩略图列表（隐藏滚动条） -->
									<div class="thumbnail-container" ref="thumbnailContainer"
										@scroll="handleThumbnailScroll">
										<div class="thumbnail-item" v-for="(item, key) in data.img" :key="key"
											:class="{ 'active': key === activeIndex }" @mouseenter="switchToImage(key)">
											<el-image :src="item" fit="cover" style="width: 100%; height: 100%;" />
										</div>
									</div>
									<!-- 右箭头 -->
									<el-button icon="ArrowRight" circle size="mini"
										style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); z-index: 1;"
										@click="scrollThumbnails(1)"></el-button>
								</el-col>
							</el-row>
						</el-col>
						<el-col :xs="{ span: 18, offset: 0 }" :sm="{ span: 18, offset: 0 }" :md="{ span: 18, offset: 0 }"
					:lg="{ span: 18, offset: 0 }" :xl="{ span: 16, offset: 0 }" class="custom-col-16">
							<el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="当前详情" name="img">
									<el-row>
										<el-col :span="24" class="">
											<div class="details">
												<div style="margin-top:10px">
													<span class="title">{{ data.brand_name }}</span>
													<span class="title" style="margin-left:30px">{{ data.model }}</span>
												</div>
												<div class="Price" style="background-color:#fff">
													<el-row class="table">
														<el-col :span="24" class="tbody_bo">
															<el-row>
																<el-col :xs="12" :sm="18" :md="20" :lg="20" :xl="18"
																	class="stock_type_txt_button">
																	<span v-for="item in data.stock_type_txt_list"
																		class="table_content" style="margin-right:20px">
																		<el-button class="A" size="large" text bg
																			v-if="item == '二手' || item == '过保' || item == '包附破损'"
																			style="">{{ item }}</el-button>
																		<el-button class="C" size="large" text bg v-else
																			color="#ff8a5c">{{ item }}</el-button>
																	</span>
																</el-col>
															</el-row>
														</el-col>
														<el-col :span="24" class="tbody_bo" style="padding-top:0px">
															<el-row>
																<el-col :span="6" class="">
																	<el-row style="margin-right:10px">
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title">品牌</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span
																				class="table_content ">{{ !data.brand_name ? '-' : data.brand_name }}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="5" class="">
																	<el-row style="margin-right:10px">
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title">品名</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span
																				class="table_content ">{{ !data.name ? "-" : data.name }}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="5" class="">
																	<el-row style="margin-right:10px">
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title">型号</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span
																				class="table_content ">{{ !data.model ? '-' : data.model }}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="5" class="">
																	<el-row style="margin-right:10px">
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title_3">订货号</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span
																				class="table_content ">{{ !data.order_no ? "-" : data.order_no }}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="3" class="">
																	<el-row>
																		<el-col :span="24" class="table_content_h"
																			style="text-align: center;">
																			<span class="table_title">数量/单位</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h"
																			style="text-align: center;">
																			<span
																				class="table_content ">{{ !data.num ? '-' : data.num }}/{{
																					!data.unit ? '-':data.unit }}</span>
																		</el-col>
																	</el-row>
																</el-col>
															</el-row>
														</el-col>
													</el-row>
												</div>
											</div>
										</el-col>
										<el-col :span="8" class="">
											<div class="details details_Price" style="margin-left:0px">
												
												<div class="Price">
													<el-row class="table" style="margin-bottom:10px">
													
														<el-col :span="24" class="tbody"
															style="margin-bottom: 10px;margin-left:25px">
															<el-row>
																<el-col :span="10" 
																	class="titlePrice">
																	<div class="">
																		<el-tooltip placement="top">
																			<template #content>
																				此信息由用户提供，仅供参考，请与发布用户核实！
																			</template>
																			<span class="table_title">单价</span>
																		</el-tooltip>
																	</div>
																</el-col>
																<el-col :span="14" 
																	class="">
																	<el-tooltip placement="top">
																		<template #content>
																			此信息由用户提供，仅供参考，请与发布用户核实！
																		</template>
																		<span
																			class="table_content table_Price">{{ data.tsw_price }}</span>
																	</el-tooltip>
																</el-col>
															</el-row>
														</el-col>
													</el-row>
												</div>
											</div>
										</el-col>
										<el-col :span="24" class="">
											<div class="details " style="margin-left:0px">
												<!-- <div>
											<span class="button" style="">
												
											</span>
										</div> -->
												<div class="Price" style="background-color:#fff">
													<el-row class="table">
														<el-col :span="24" class="tbody" style="margin-left:25px">
															<el-row>
																<el-col :xs="12" :sm="8" :md="6" :lg="3" :xl="3"
																	class="">
																	<div class="">
																		<span class="table_title_3">备注</span>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="16" :md="18" :lg="21" :xl="21"
																	class="">
																	<span class="table_content">{{ data.remark }}</span>
																</el-col>
															</el-row>
														</el-col>
													</el-row>
												</div>
											</div>
										</el-col>
										<el-col :span="24" class="">
											<div class="details">
												<div>
													<span class=""
														style="color:#ff8a5c;padding-left: 25px;font-size:30px">联系方式</span>
													<!-- <span class="button" style="float: right;">
										<el-button type="success" size="small" plain>{{data.stock_type_txt}}</el-button>
									</span> -->
												</div>
												<div class="Price" style="background-color:#fff;color:#8B8B8B">
													<el-row class="table">
														<!-- <el-col :span="24" class="tbody_bo">
													<el-row>
														<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title">数量</span>
															</div>
														</el-col>
														<el-col :span="12" class="">
															<span class="table_content ">{{data.num}}</span>
														</el-col>
													</el-row>
												</el-col> -->
														<el-col :span="24" class="tbody_bo">
															<el-row>
																<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3"
																	class="">
																	<div class="">
																		<span class="table_title_3">联系电话</span>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="6" :md="7" :lg="9" :xl="9"
																	class="">
																	<span
																		class="table_content ">{{ !data.user_mobile ? '-' : data.user_mobile }}</span>
																</el-col>
																<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3"
																	class="">
																	<div class="">
																		<span class="table_title_3">联系人</span>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="6" :md="7" :lg="9" :xl="9"
																	class="">
																	<span
																		class="table_content ">{{ !data.user_linkman ? '-' : data.user_linkman }}</span>
																</el-col>
															</el-row>
														</el-col>

														<el-col :span="4" class="tbody_bo">
															<div
																style="display: flex; justify-content: left; align-items: center; height: 100%;">
																<el-icon size="28" @click.stop="chat_click(data.id)"
																	style="color:var(--el-color-primary);  cursor: pointer;">
																	<ChatDotSquare />
																</el-icon>
															</div>
														</el-col>
													</el-row>
												</div>
											</div>
										</el-col>
									</el-row>
								</el-tab-pane>
								<el-tab-pane label="疑似关联" name="list">
									<template #label>

										<span v-if="data.associate.length">
											<el-badge :max="10000000" :value="data.associate.length" class="item">
												<span>疑似关联</span>
											</el-badge>
										</span>
										<span v-else>
											<span>疑似关联</span>
										</span>
									</template>

									<div class="goodDetails_name_img">
										<div class="associate-tab-wrapper">
											<div class="associate-table">
												<!-- 表头 -->
												<div class="associate-table-header">
													<div class="th col-type">脱手商品</div>
													<div class="th col-status">货物状态</div>
													<div class="th col-brand">品牌</div>
													<div class="th col-model">型号</div>
													<div class="th col-orderno">订货号</div>
													<div class="th col-num">数量</div>
													<div class="th col-price">脱手单价</div>
													<div class="th col-estimate">市场估价</div>
												</div>
												<!-- 主商品固定数据 -->
												<div class="associate-table-row main-row">
													<div class="td col-type"><span class="tag-main">脱手商品</span></div>
													<div class="td col-status">
														<div class="stock_type_txt_button">
															<span
																v-for="(item, idx) in (data.stock_type_txt ? data.stock_type_txt.split('、') : [])"
																:key="idx">
																<el-button style="font-size: 0.75rem !important;"
																	class="A" size="small" text bg
																	v-if="item == '二手' || item == '过保' || item == '包附破损'">{{
																		item
																	}}</el-button>
																<el-button style="font-size: 0.75rem !important;"
																	class="C" size="small" text bg v-else
																	color="#ff8a5c">{{ item
																	}}</el-button>
															</span>
														</div>
													</div>
													<div class="td col-brand">{{ data.brand_name || '-' }}</div>
													<div class="td col-model">{{ data.model || '-' }}</div>
													<div class="td col-orderno">{{ data.order_no || '-' }}</div>
													<div class="td col-num">{{ data.num || '-' }}</div>
													<div class="td col-price price-value">{{ data.tsw_price || '-' }}
													</div>
													<div class="td col-estimate price-value">{{ '-' }}</div>
												</div>
												<!-- 疑似关联卡片模式 -->
												<div class="associate-cards">
													<div class="associate-card" v-for="(item, index) in data.associate">
														<div class="associate-card-row">
															<div class="td col-type"><span
																	class="tag-associate">疑似关联</span></div>
															<div class="td col-status"><span class="stock-tag">全新</span>
															</div>
															<div class="td col-brand">{{ item.brand_name || '-' }}</div>
															<div class="td col-model">{{ item.model || '-' }}</div>
															<div class="td col-orderno">{{ item.order_no || '-' }}</div>
															<div class="td col-num">{{ '-' }}</div>
															<div class="td col-price price-value">{{ '-' }}</div>
															<div class="td col-estimate price-value">{{ item.real_price
																|| '-' }}</div>
														</div>
														<div class="associate-card-remark" v-if="item.remark">
															<span class="remark-label">备注：</span>
															<span class="remark-content"
																v-html="item.remark.replace(/\n/g, '<br>')"></span>
														</div>
													</div>
												</div>
												<!-- 联系方式模块 -->

											</div>
										</div>
										<!-- 联系方式模块（固定底部） -->
										<div class="contact-module">
											<div class="contact-title" style="text-align: left;">联系方式</div>
											<div class="contact-info">
												<div class="contact-item">
													<span class="contact-label">联系人：</span>
													<span class="contact-value">{{ data.user_linkman || '-' }}</span>
												</div>
												<div class="contact-item">
													<span class="contact-label">联系电话：</span>
													<span class="contact-value">{{ data.user_mobile || '-' }}</span>
												</div>

											</div>
										</div>
									</div>
								</el-tab-pane>
							</el-tabs>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
		<el-image-viewer v-if="showPreview" :url-list="srcList" show-progress :initial-index="srcList_index"
			@close="showPreview = false" />
		<chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
	</div>
</template>
<script>
import '../../assets/product/index.css' //优化表格样式
import { ElMessage, ElMessageBox } from 'element-plus'
import { ChatDotSquare } from '@element-plus/icons-vue'
import HeadIndex from '../public/HeadIndex';
import chat from '../public/chat';
export default {
	name: 'product',
	components: {
		HeadIndex,
		chat,
		ChatDotSquare
	},
	data() {

		return {
			activeName: 'img',
			activeIndex: 0, // 当前激活的轮播图索引
			hasScrollLeft: false, // 是否可以向左滚动
			hasScrollRight: false, // 是否可以向右滚动
			num: 1,
			tableHeight: '',
			srcList_index: '',
			srcList: [],
			showPreview: false,
			data: { associate: [] },
			id: '',
			chat_info: false,
		}
	},
	props: [],

	updated() {

	},


	mounted() {
		this.handleThumbnailScroll();
	},

	activated() {

	},
	created() {

		this.id = this.$route.query.id
		this.search();
		this.tableHeight_fun();
	},
	watch: {

	},
	methods: {
		handleClick() {

		},
		// 鼠标移入缩略图，切换到对应轮播图
		switchToImage(key) {
			this.activeIndex = key;
			if (this.$refs.carousel) {
				this.$refs.carousel.setActiveItem(key);
			}
		},

		// 滚动缩略图（1：向右，-1：向左）
		scrollThumbnails(direction) {

			if (direction === 1) {
				// 向右滚动
				if (this.data.img.length == (this.activeIndex + 1)) {
					this.activeIndex = 0
				} else {
					this.activeIndex = this.activeIndex + 1;
				}
				console.log(this.activeIndex)
			} else {
				// 向左滚动
				if (this.activeIndex === 0) {
					this.activeIndex = this.data.img.length - 1
				} else {
					this.activeIndex = this.activeIndex - 1;
				}
			}

			this.$refs.carousel.setActiveItem(this.activeIndex);
			// 同步更新轮播图索引

		},

		// 监听缩略图容器滚动，判断是否可以继续滚动
		handleThumbnailScroll() {
			const container = this.$refs.thumbnailContainer;
			if (!container) return;

			const { scrollLeft, scrollWidth, clientWidth } = container;
			// 可以向左滚动：scrollLeft > 0
			this.hasScrollLeft = scrollLeft > 10; // 留10px缓冲，避免边界判断不准
			// 可以向右滚动：scrollLeft + clientWidth < scrollWidth
			this.hasScrollRight = scrollLeft + clientWidth < scrollWidth - 10;
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
				this.tableHeight = (this.tableHeight > 550) ? this.tableHeight : 550
			})
		},
		preview(key) {
			this.srcList = [];
			this.srcList_index = key
			this.showPreview = true;
			var obj = this;
			this.data.img.forEach(function (item) {
				obj.srcList.push(item)
			})
		},
		async search() {
			var search = { id: this.id }
			await this.$axios.post('/api/yunsys.Storage/getonestorage', search).then(async (res) => {
				var res = res.data;
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				var obj = this;
				if (res.data.stock_type_txt) {
					res.data.stock_type_txt_list = res.data.stock_type_txt.split("、");
				} else {
					res.data.stock_type_txt_list = []
				}

				res.data.real_money = obj.$bn.multiply(res.data.sur_num, res.data.real_price, 2);
				res.data.real_price = obj.$bn.multiply(res.data.real_price, 1, 2);
				res.data.tsw_price = obj.$bn.multiply(res.data.tsw_price, 1, 2);
				res.data.tsw_discount = obj.$bn.divide(res.data.tsw_price, res.data.price, 2)
				this.data = res.data;
				document.title = this.data.model;

			})
				.catch(err => {
					console.log(err)
					return ElMessage({
						message: '无此商品',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		closeChat() { this.chat_info = false },
		async chat_click(id) {
			await this.$axios.post('/api/yunsys.storage/addchat', { id }).then(res => {
				const d = res.data
				if (d.code !== 0) return ElMessage.error(d.msg)
				this.chat_info = false
				this.$nextTick(() => {
					this.chat_info = true
					this.$nextTick(() => {
						if (this.$refs.chat) {
							this.$refs.chat.dialogTableVisible = true
							this.$refs.chat.pitch_id = d.data.data
							this.$refs.chat.admin_pitch_id = d.data.data
							this.$refs.chat.search()
						}
					})
				})
			}).catch(() => ElMessage.error('系统错误'))
		}
	}
}
</script>
<style lang="less" scoped>
/* 缩略图容器样式 */
.thumbnail-container {
	display: flex;
	gap: 10px;
	/* 缩略图之间的间距 */
	padding: 10px 40px;
	/* 左右留出箭头位置 */
	overflow-x: auto;
	/* 允许水平滚动 */
	white-space: nowrap;
	/* 防止换行 */
	scrollbar-width: none;
	/* 隐藏Firefox滚动条 */
}

/* 隐藏Chrome/Safari滚动条 */
.thumbnail-container::-webkit-scrollbar {
	display: none;
}

/* 缩略图项样式（固定正方形） */
.thumbnail-item {
	width: 50px;
	/* 缩略图宽度 */
	height: 50px;
	/* 缩略图高度（与宽度一致，固定正方形） */
	border-radius: 9px;
	cursor: pointer;
	transition: all 0.3s ease;
	border: 2px solid transparent;
	/* 默认透明边框 */
}

/* 激活的缩略图高亮样式 */
.thumbnail-item.active {
	border-color: #ff8a5c;
	/* 与轮播图边框颜色一致 */
	box-shadow: 0 0 5px rgba(255, 138, 92, 0.5);
	transform: scale(1.05);
	/* 轻微放大效果 */
}

:deep(.el-tabs__item.is-active) {
	// background-color: #f56c6c; /* 选中标签的背景颜色 */
	//border-color: #f56c6c; /* 选中标签的边框颜色 */
	color: #ff8a5c;
	/* 选中标签的文字颜色 */
}

:deep(.el-tabs__active-bar) {
	background-color: #ff8a5c;
	/* 选中标签下方的横线颜色 */
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}

:deep(.el-input-group__append) {

	background: #ff8a5c;
}

:deep(.remark_descriptions) {
	height: 80px;
}

:deep(.el-tabs__nav-scroll) {
	overflow: hidden;
	margin-left: 20px;
}

:deep(.product .table .el-button > span) {
	font-size: 19.5px;
}

.thumbnail-item :deep(.el-image) {
	border: 0px solid #eee;
}

.Price tr {
	//height: calc(var(--tableHeight) / 8);
}

.logo_m {
	margin-top: 50px;
	height: 20px
}

.Page_heading {
	margin-top: 0px;

}

.stock_type_txt_button .el-button {
	margin-right: 3px;
	font-size: 12px !important;
	padding: 2px 8px !important;
	line-height: 1.4 !important;
	min-height: 22px !important;
}

.stock_type_txt_button .A {
	color: #ff8a5c;
	background-color: rgb(255, 240, 228) !important;
}

:deep(.my-label) {
	background: #ff8a5c !important;
}

:deep(.my-content) {
	background: #ff8a5c !important;
}

.stock_type_txt_button .B {
	color: red;
	background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205);
	background-color: rgb(223, 255, 251) !important;
}

.stock_type_txt {
	line-height: 22px
}

/* ========== 关联商品表格容器 ========== */
.associate-table {
	border: 1px solid #ebeef5;
	border-radius: 8px;
	overflow: hidden;
	background: #fff;
	margin: 10px 0;
	min-width: 960px;
}

/* ========== 表头 ========== */
.associate-table-header {
	display: flex;
	background: #f5f7fa;
	color: #606266;
	font-weight: 600;
}

.associate-table-header .th {
	padding: 10px 2px;
	text-align: center;
	border-right: 1px solid #ebeef5;
	line-height: 1.4;
	box-sizing: border-box;
}

.associate-table-header .th:last-child {
	border-right: none;
}

/* ========== 列宽定义（与主商品行共享） ========== */
.col-type {
	width: 10%;
	min-width: 100px;
}

.col-status {
	width: 18%;
	min-width: 160px;
}

.col-brand {
	width: 15%;
	min-width: 120px;
}

.col-model {
	width: 18%;
	min-width: 160px;
}

.col-orderno {
	width: 19%;
	min-width: 150px;
}

.col-num {
	width: 6%;
	min-width: 56px;
}

.col-price {
	width: 7%;
	min-width: 70px;
}

.col-estimate {
	width: 7%;
	min-width: 70px;
}

/* ========== 表格行 ========== */
.associate-table-row {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #ebeef5;
	box-sizing: border-box;
}

.associate-table-row:last-child {
	border-bottom: none;
}

.associate-table-row .td {
	padding: 12px 2px;
	text-align: center;
	border-right: 1px solid #ebeef5;
	line-height: 1.4;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	box-sizing: border-box;
}

.associate-table-row .td:last-child {
	border-right: none;
}

/* ========== 主商品行 ========== */
.associate-table-row.main-row {
	background: #f5f7fa;
	font-weight: 500;
}

.associate-table-row.main-row:hover {
	background: #ebeef5;
}

/* ========== 标签样式 ========== */
.tag-main {
	display: inline-block;
	padding: 4px 12px;
	background: linear-gradient(135deg, #ff8a5c 0%, #ffa679 100%);
	color: #fff;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 500;
}

.tag-associate {
	display: inline-block;
	padding: 4px 12px;
	background: linear-gradient(135deg, #4bd4cd 0%, #6ee8e2 100%);
	color: #fff;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 500;
}

/* ========== 库存状态标签 ========== */
.stock-tag {
	display: inline-block;
	padding: 4px 12px;
	background: #dcfce7;
	color: #16a34a;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 500;
}

/* ========== 价格高亮 ========== */
.price-value {
	color: #f56c6c;
	font-weight: 500;
	font-size: 15px;
}

/* ========== 关联卡片容器 ========== */
.associate-cards {
	display: flex;
	flex-direction: column;
	gap: 0;
}

/* ========== 卡片主体 ========== */
.associate-card {
	padding: 0;
	overflow: hidden;
	box-sizing: border-box;
}

/* ========== 卡片行（与主数据行对齐） ========== */
.associate-card-row {
	display: flex;
	align-items: center;
	padding: 0;
	border-bottom: 1px solid #ebeef5;
	box-sizing: border-box;
	flex-wrap: nowrap;
}

.associate-card-row:last-child {
	border-bottom: none;
}

.associate-card-row .td {
	padding: 12px 2px;
	text-align: center;
	border-right: 1px solid #ebeef5;
	line-height: 1.4;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	box-sizing: border-box;
}

.associate-card-row .td:last-child {
	border-right: none;
}

/* ========== 卡片备注行 ========== */
.associate-card-remark {
	padding: 8px 16px;
	background: #fafbfc;
	border-top: 1px dashed #e4e7ed;
	text-align: right;
}

.remark-label {
	color: #ff8a5c;
	font-weight: 600;
	margin-right: 4px;
}

.remark-content {
	color: #606266;
	line-height: 1.6;
}

/* ========== 疑似关联 tab 整体滚动容器 ========== */
.associate-tab-wrapper {
	height: calc(62vh - 80px);
	overflow: auto;
	padding-right: 6px;
	box-sizing: border-box;
}

.associate-tab-wrapper::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}

.associate-tab-wrapper::-webkit-scrollbar-thumb {
	background: #c0c4cc;
	border-radius: 3px;
}

.associate-tab-wrapper::-webkit-scrollbar-track {
	background: #f0f2f5;
}

/* ========== 联系方式模块 ========== */
.contact-module {
	margin-top: 12px;
	padding: 12px 16px;
	background: #f5f7fa;
	border: 1px solid #ebeef5;
	border-radius: 8px;
}

.contact-title {
	font-size: 14px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 8px;
	padding-bottom: 6px;
	border-bottom: 1px solid #ebeef5;
}

.contact-info {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
}

.contact-item {
	display: flex;
	align-items: center;
	min-width: 0;
}

.contact-label {
	color: #909399;
	font-size: 13px;
	white-space: nowrap;
	margin-right: 4px;
}

.contact-value {
	color: #303133;
	font-size: 13px;
	font-weight: 500;
}
</style>